import { render, staticRenderFns } from "./ClientPricelist.vue?vue&type=template&id=7d395a9c&"
import script from "./ClientPricelist.vue?vue&type=script&lang=js&"
export * from "./ClientPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports